<template>
  <div class="form-switch">
    <input type="checkbox" v-bind="{ id, name, disabled, required, value }" @change.stop="toggleCheck" :checked="isSelected">

    <label :for="id"></label>

    <label class="form-switch-label" :for="id" v-if="hasSlot">
      <slot></slot>
    </label>
  </div>
</template>

 <script>
  import FormInputEmit from '../FormInputEmit'

  export default {
    name: 'form-switch',
    mixins: [
      FormInputEmit
    ]
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .form-switch {
    display: flex;
    align-items: center;

    &.error {
      label {
        color: $color-red;
      }

      input + label {

        &:before {
          background-color: rgba($color-red, .12);
          border-color: $color-red;
        }
      }
    }

    input {
      opacity: 0;
      height: 0;
      width: 0;
      pointer-events: none;
      position: absolute;

      + label {
        flex: none;
        min-width: 32px;
        min-height: 15px;
        height: 18px;
        position: relative;

        &:before {
          content: '';
          display: block;
          border-radius: 5px;
          width: 32px;
          height: 12px;
          background-color: rgba(18, 142, 206, .3);
          box-shadow: none;
          border: 1px solid $color-sidebar;
          transition: border-color .3s $transition-ease-out;
        }

        &:after {
          content: '';
          width: 18px;
          height: 18px;
          background: #838F92;
          border-radius: 50%;
          left: 0;
          top: 0;
          opacity: 1;
          transform: scale(1);
          position: absolute;
          transition: transform .2s $transition-ease-in-out, background-color .2s $transition-ease-in-out;
        }
      }

      &:checked {
        & + label {
          &:after {
            transform: scale(1) translate3d(14px, 0,0);
            background-color: $color-blue;
          }
        }
      }
    }

    label {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      cursor: pointer;
      user-select: none;

      + label {
        margin-left: 10px;
      }
    }
  }

  .form-switch-label {
    min-height: 20px;
    margin-left: 10px;
  }
</style>
